import { EnemyWeaponConfig } from "../../GameConfig/EnemyConfig.js";
import Weapon from "./weapon.js";

export default class Bullet extends Weapon {
  constructor(x, y) {
    super();

    this.spriteWidth = EnemyWeaponConfig.Bullet.SPRITE_WIDTH;
    this.spriteHeight = EnemyWeaponConfig.Bullet.SPRITE_HEIGHT;

    this.x = x;
    this.y = y;

    this.image.src = EnemyWeaponConfig.Bullet.IMG_SRC;
    this.maxFrame = EnemyWeaponConfig.Bullet.MAX_FRAME;

    this.speed = EnemyWeaponConfig.Bullet.SPEED;
    this.damage = EnemyWeaponConfig.Bullet.DAMAGE;
  }
}
